import React, { useEffect } from 'react';
import { Box, Container, Stack, Typography, FormControl, MenuItem, InputLabel } from '@mui/material';
import { WO2Select } from 'src/common/components';
import { Props } from '../container';
import { ReportSettingsAssetClassOrderTable } from './ReportSettingsAssetClassOrderTable';
import { ReportSettingsAssetClassOverrideTable } from './ReportSettingsAssetClassOverrideTable';
import { UpsertAssetClassOrderPayload, UpsertAssetClassOverridePayload } from '../store/types';

export const ReportSettings = ({
  match,
  afsls,
  fetchAfsls,
  afslId,
  setAfslId,
  assetClassOrderItems,
  assetClassOverrideItems,
  reportSettingsLoadingProgress,
  fetchAssetClassOrder,
  fetchAssetClassOverride,
  upsertAssetClassOrder,
  upsertAssetClassOverride,
}: Props): JSX.Element => {
  useEffect(() => {
    fetchAfsls();
  }, [fetchAfsls]);

  useEffect(() => {
    setAfslId(+match.params.afslId);
  }, [match.params.afslId]);

  useEffect(() => {
    if (!!afslId) {
      fetchAssetClassOrder({ afslId });
    }
  }, [afslId, fetchAssetClassOrder]);

  useEffect(() => {
    if (!!afslId) {
      fetchAssetClassOverride({ afslId });
    }
  }, [afslId, fetchAssetClassOverride]);

  return (
    <>
      <Box style={{ paddingTop: '20px' }}>
        <Container>
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography variant="h2">Settings</Typography>
          </Box>
        </Container>
        <Stack direction="row" width={'100%'}>
          <Box display={'flex'} justifyContent={'space-between'} paddingTop="30px" paddingRight={'10px'} width="70%">
            {afsls.length > 1 && (
              <FormControl variant="outlined" style={{ width: '260px' }}>
                <InputLabel id="afsl-select-label">Afsl</InputLabel>
                <WO2Select
                  labelId="afsl-select-label"
                  id="afsl-select"
                  value={afslId || ''}
                  onChange={(event) => {
                    setAfslId(+`${event.target.value}`);
                  }}
                  label={'Portfolio'}
                  style={{ width: '600px' }}
                >
                  {afsls.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </WO2Select>
              </FormControl>
            )}
          </Box>
        </Stack>
      </Box>
      <div style={{ width: '100%', paddingTop: '30px' }}>
        <Typography variant="h3" style={{ paddingBottom: '20px' }}>
          AssetClass settings
        </Typography>
        <ReportSettingsAssetClassOrderTable
          afslId={afslId}
          assetClassOrderItems={assetClassOrderItems}
          onSave={async (upsertAssetClassOrderPayload: UpsertAssetClassOrderPayload) => {
            if (!!afslId) {
              await upsertAssetClassOrder(upsertAssetClassOrderPayload);
            }
          }}
          itemLoadingProgress={reportSettingsLoadingProgress}
          savingProgress={reportSettingsLoadingProgress}
        />
      </div>
      <div style={{ width: '100%', paddingTop: '30px' }}>
        <Typography variant="h3" style={{ paddingBottom: '20px' }}>
          AssetClass overrides
        </Typography>
        <ReportSettingsAssetClassOverrideTable
          afslId={afslId}
          assetClassOverrideItems={assetClassOverrideItems}
          onSave={async (upsertAssetClassOverridePayload: UpsertAssetClassOverridePayload) => {
            if (!!afslId) {
              await upsertAssetClassOverride(upsertAssetClassOverridePayload);
            }
          }}
          itemLoadingProgress={reportSettingsLoadingProgress}
          savingProgress={reportSettingsLoadingProgress}
        />
      </div>
    </>
  );
};
